import React, { useContext, useEffect, useState } from 'react'
import { Popup } from '../../../components/Popup'
import ScheduleCalendar from '../../../components/ScheduleCalendar'
import { Text, Box, Button } from '../../../designSystem'
import { convertUrlToHttps } from '../../../lib/utils'
import { ErrorBox, HR, ScheduleButton, ScheduleChapterTitle, ScheduleDateInput, ScheduleSelectText, ScheduleTimeCard, Thumbnail, ThumbnailDiv } from './styles'
import CalendarClock from '../../../components/Images/CalendarClock'
import InfoIcon from '../../../components/Images/InfoIcon'
import CustomTooltip from '../../../CustomTooltip'
import CrossIcon from '../../../components/Images/CrossIcon'
import { AccountContext } from '../../../providers/accountProvider'
import { CautionText } from './ChapterAddEdit/VoiceSelection/styles'
import Loader from '../../../components/Loader'

function ChapterScheduler({ toggleSchedulerPopup, novelDetails, chapterDetails, handleVersionPublish, isSubmitting }){
    const [isChapterScheduled, setChapterScheduled] = useState(!!novelDetails?.future_published_chapters?.length)
    const [showCalendar, toggleCalendar] = useState(false)
    const [publishedDates, setPublishedDates] = useState([])
    const [userCalendarDate,setUserCalendarDate]=useState('');
    const [errorMsg,setErrorMsg] = useState({ isShown : false, msg : ''})
    const { isUgcUser } = useContext(AccountContext)
    const isMobile = window.screen.width < 600
    const showVoiceAndBackgroundSelection = novelDetails?.is_novel === 2 && novelDetails?.stats?.published_chapter_count === 0
    useEffect(() => {
        // const nextDay = new Date(new Date().setDate(new Date().getDate() + 1)) 
        if((novelDetails?.stats?.word_count || 0) + chapterDetails.wordCount < 30000){
            setChapterScheduled(false)
        }else if(novelDetails?.future_published_chapters?.length === 0 && novelDetails?.current_day_published_chapters?.length !== 0){
            if(((novelDetails?.stats?.word_count || 0) + chapterDetails?.wordCount >= 30000)){
                // setUserCalendarDate(`${new Date(nextDay).getDate()}-${months[new Date(nextDay).getMonth()]}-${new Date(nextDay).getFullYear()}`)
                setChapterScheduled(false)
            }
        }
        setPublishedDates([...novelDetails?.current_month_published_chapters, ...novelDetails?.current_day_published_chapters, ...novelDetails?.future_published_chapters])
    },[novelDetails])

    const handlePublishAfterSchedule = () => {
        if(!isChapterScheduled) handleVersionPublish()
        else if(isChapterScheduled && userCalendarDate === ''){
            setErrorMsg({ isShown : true, msg : 'Please select the publish date in order to schedule the chapter.', isPublishDateErr : true})
        }else{
            handleVersionPublish(userCalendarDate)
        }
    }

    const onToggleYesNo = () => {
        if(isChapterScheduled && novelDetails?.future_published_chapters.length > 0){
            setErrorMsg({ isShown : true, msg : "Cannot directly publish chapter now when scheduled chapter exists."})
        }else if(!isChapterScheduled && novelDetails?.stats?.published_chapter_count === 0){
            setErrorMsg({ isShown : true, msg : "Cannot Schedule chapter when the book has less than 30,000 words or current day doesn't have chapters."})
        }else if(!isChapterScheduled && !novelDetails?.future_published_chapters?.length && !novelDetails?.current_day_published_chapters?.length){
            setErrorMsg({ isShown : true, msg : "Cannot Schedule chapter when current day doesn't have published chapters."})
        }else if(!isChapterScheduled && ((novelDetails?.stats?.word_count || 0) + chapterDetails.wordCount < 30000)){
            setErrorMsg({ isShown : true, msg : "Cannot Schedule chapter when the book has less than 30,000 words."})
        }else{
            setChapterScheduled(!isChapterScheduled)
        }
        setTimeout(() => {
            setErrorMsg({ isShown : false, msg : ''})
        },5000)
    }

    return(
        <>
            <Popup 
                show
                className={isMobile ? "bottom-sheet no-margin calender-details no-padding" : "right-drawer-episode-form"} 
                close={() => toggleSchedulerPopup(false)}
                fullHeight='full-height-details'
            >
                <Box m={[8,16]} display={isMobile && showCalendar ? 'none'  : 'block'} position="relative" height={!isMobile && '95%'}>
                    <Text variant="headingPrimary">Publish Planner</Text>
                    <Box my={16} display="flex">
                        <ThumbnailDiv>
                            <Thumbnail src={convertUrlToHttps(novelDetails.image_url)}/>
                        </ThumbnailDiv>
                        <Box my={[0,8]} mr={24} overflow="hidden">
                            <ScheduleChapterTitle>{chapterDetails?.title}</ScheduleChapterTitle>
                            <Text variant="caption" mt={4}>{chapterDetails?.wordCount}</Text>
                        </Box>
                    </Box>
                    <Box mt={32} ml={8} display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                            <Text>Schedule it for later? <CustomTooltip content="Schedule Chapters in the next 3 days will available for readers for early access in the new app version." direction="bottom"><InfoIcon /></CustomTooltip></Text>
                        </Box>
                        <Box display="flex">
                            <ScheduleButton selected={!isChapterScheduled} onClick={onToggleYesNo}>No</ScheduleButton>
                            <ScheduleButton selected={isChapterScheduled} onClick={onToggleYesNo}>Yes</ScheduleButton>
                        </Box>
                    </Box>
                    {isChapterScheduled && 
                    <>
                        <Box mt={16} ml={8} display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                                <Text>Publish Date</Text>
                            </Box>
                            <Box display="flex" alignItems="center"  onClick={() => toggleCalendar(true)}>
                                <ScheduleDateInput isPublishDateErr={errorMsg?.isPublishDateErr}>{userCalendarDate}</ScheduleDateInput>
                                <CalendarClock />
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="flex-end" onClick={() => toggleCalendar(true)}>
                            <ScheduleSelectText>{userCalendarDate === '' ? 'Select' : 'Change'}</ScheduleSelectText>
                        </Box>
                        {showCalendar && 
                        <Box>
                            <ScheduleCalendar 
                                publishedDates={publishedDates}
                                setUserCalendarDate={setUserCalendarDate}
                                close={() => toggleCalendar(false)}
                                openPublishPopup={() => toggleSchedulerPopup(true)}
                                onBackClick={() => toggleCalendar(false)}
                                setErrorMsg={setErrorMsg}
                            />
                        </Box>}
                        <ScheduleTimeCard>
                            <CautionText>
                                {isUgcUser ? <>Default Publish Time is 00:30 AM UTC <br/> [ 8:30 PM EST , Previous Day]</> : 'Default Publish Time is 06:00 AM (IST)'}
                            </CautionText>
                        </ScheduleTimeCard>
                    </>}
                    <HR />
                    <Box my={16} display="flex" justifyContent="space-between" alignItems="center" flexDirection={['column-reverse','row']}>
                        <Button variant="semiFillDanger" onClick={() => toggleSchedulerPopup(false)}>Cancel</Button>
                        <Button mb={[16,0]} onClick={handlePublishAfterSchedule}>{isSubmitting ? <Loader size="xs" invertColor noPadding /> : 'Publish'}</Button>
                    </Box>
                    
                    {errorMsg.isShown && <ErrorBox>
                        <p>{errorMsg.msg}</p>
                        <CrossIcon  onClick={() => setErrorMsg({isShown : false})}/>
                    </ErrorBox>}
                </Box>
                <Box display={isMobile && showCalendar ? 'block'  : 'none'} height={400} mt={8} p={16}>
                    <ScheduleCalendar 
                        publishedDates={publishedDates}
                        setUserCalendarDate={setUserCalendarDate}
                        close={() => toggleCalendar(false)}
                        openPublishPopup={() => toggleSchedulerPopup(true)}
                        onBackClick={() => toggleCalendar(false)}
                    />
                </Box>
            </Popup>
        </>
    )
}

export default ChapterScheduler
